import { Component, ViewChild } from '@angular/core';
import { IonicPage, NavController, NavParams, ViewController } from 'ionic-angular';
import { AngularCropperjsComponent } from 'angular-cropperjs';


/**
 * Generated class for the ProfileCropPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-profile-crop',
  templateUrl: 'profile-crop.html',
})
export class ProfileCropPage {

  @ViewChild('angularCropper') public angularCropper: AngularCropperjsComponent;

  cropperOptions: any;
  croppedImage = null;

  myImage = null;
  scaleValX = 1;
  scaleValY = 1;

  constructor(public navCtrl: NavController, public navParams: NavParams, private view: ViewController) {

    this.cropperOptions = {
      dragMode: 'crop',
      aspectRatio: 1,
      autoCrop: true,
      movable: true,
      zoomable: true,
      scalable: true,
      autoCropArea: 0.8,
    };

  }

  ionViewWillLoad(){

  this.myImage = this.navParams.get('data');

  }

  reset() {
    this.angularCropper.cropper.reset();
  }

  done() {

    let croppedImgB64String: string = this.angularCropper.cropper.getCroppedCanvas().toDataURL('image/jpeg', (50 / 100));

    this.view.dismiss(croppedImgB64String);
   // this.croppedImage = croppedImgB64String;
  }

  ionViewDidLoad() {
    console.log('ionViewDidLoad ProfileCropPage');
  }

}



// WEBPACK FOOTER //
// ./src/pages/profile-crop/profile-crop.ts